import { render, staticRenderFns } from "./communityMembers.vue?vue&type=template&id=bcd60728&scoped=true"
import script from "./communityMembers.vue?vue&type=script&lang=js"
export * from "./communityMembers.vue?vue&type=script&lang=js"
import style0 from "./communityMembers.vue?vue&type=style&index=0&id=bcd60728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd60728",
  null
  
)

export default component.exports